<!--<div class="col-lg-12 text-center" *ngIf="getParameterDetailLoader" style="margin-top: 50px;">-->
<!--  <img src="/assets/images/load.gif" />-->
<!--</div>-->

<!--<div *ngIf="!getParameterDetailLoader" class="panel-group panel-group-control content-group-lg">-->

<!--  <div class="panel" *ngFor="let parameter of parameterDetails let i = index" [attr.data-index]="i">-->
<!--    <div class="panel-heading">-->
<!--      <h6 class="panel-title">-->
<!--        <a data-toggle="collapse" [ngClass]="{'collapsed': i != 0}" href="#collapsible-control-group{{i}}"><strong>{{parameter.station_name}} | </strong> <strong class="text-blue-700">{{parameter.device_name}} </strong> <strong> | {{parameter.name}}</strong> </a>-->
<!--      </h6>-->

<!--      <a [hidden]="(type == 'view')?true:false" class="delicon" (click)="delete(parameterDetails[i]['id'])">-->
<!--        <i class="fa fa-trash" aria-hidden="true" title="Delete Parameter" style="color: #fff;background: red;padding:7px 8px 8px 8px; font-size:16px;border-radius:16px;cursor: pointer;"></i>-->
<!--      </a>-->

<!--    </div>-->
<!--    <div id="collapsible-control-group{{i}}" [ngClass]="{'in': i == 0}" class="panel-collapse collapse">-->
<!--      <div class="panel-body">-->

<!--        <div class="form-horizontal">-->

<!--          <fieldset class="content-group">-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Parameter Name*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="parameterDetails[i]['paramkey']" placeholder="Enter parameter name" class="form-control">-->
<!--                <div *ngIf="formErrorParameterName[i] && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorParameterName[i]}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Units*-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="text" [disabled]="(type == 'view')?true:false" [(ngModel)]="parameterDetails[i]['stdunit']" placeholder="Enter units" class="form-control">-->
<!--                <div *ngIf="formErrorUnit[i] && error">-->
<!--                  <span style=" margin-left: 5px; color: red; font-weight: 900;">*{{formErrorUnit[i]}}</span>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Min value-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="number"  [disabled]="(type == 'view')?true:false" [(ngModel)]="parameterDetails[i]['min']" placeholder="Enter min value" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group">-->
<!--              <label class="control-label col-lg-2">-->
<!--                Max value-->
<!--              </label>-->
<!--              <div class="col-lg-10">-->
<!--                <input autocomplete="off" pattern="^[^<>]*$" type="number"  [disabled]="(type == 'view')?true:false" [(ngModel)]="parameterDetails[i]['max']" placeholder="Enter max value" class="form-control">-->
<!--              </div>-->
<!--            </div>-->

<!--            <div class="form-group" *ngIf="type == 'edit'">-->
<!--              <div class="col-lg-12" *ngIf="!updateParameterLoader">-->

<!--                <div class="col-lg-1 pull-right">-->
<!--                  <button (click)="validateParameter(i)" type="submit" class="btn btn-primary">-->
<!--                    <strong>Update</strong>-->
<!--                  </button>-->
<!--                </div>-->

<!--                <div class="col-lg-1 pull-right">-->
<!--                  <button (click)="getParameterDetail()" type="button" class="btn btn-danger">-->
<!--                    <strong>Reset</strong>-->
<!--                  </button>-->
<!--                </div>-->
<!--              </div>-->

<!--              <div class="col-lg-12" *ngIf="updateParameterLoader">-->
<!--                <span class="pull-right"><img style="width: 60%;" src="/assets/images/load.gif" /></span>-->
<!--              </div>-->
<!--            </div>-->
<!--          </fieldset>-->
<!--        </div>-->

<!--      </div>-->
<!--    </div>-->
<!--  </div>-->

<!--</div>-->
<!--&lt;!&ndash; /collapsible with left control button &ndash;&gt;-->
<div class="col-lg-12 text-center mt-5" *ngIf="getParameterDetailLoader">
  <img src="/assets/images/load.gif" class="img-fluid" />
</div>

<div *ngIf="!getParameterDetailLoader" class="accordion" id="parameterAccordion">

  <div class="accordion-item mb-3" *ngFor="let parameter of parameterDetails; let i = index" [attr.data-index]="i">
    <h2 class="accordion-header" id="heading{{i}}">
      <button class="accordion-button d-flex justify-content-between align-items-center" type="button"
              [ngClass]="{'collapsed': i != 0}"
              data-bs-toggle="collapse"
              [attr.data-bs-target]="'#collapse' + i"
              aria-expanded="i === 0 ? 'true' : 'false'"
              [attr.aria-controls]="'collapse' + i">
        <span>
          <strong>{{parameter.station_name}} | </strong>
          <strong class="text-primary">{{parameter.device_name}} </strong>
          <strong> | {{parameter.name}}</strong>
        </span>
        <a *ngIf="type !== 'view'" class="ms-2" (click)="$event.stopPropagation(); delete(parameterDetails[i]['id'])">
          <i class="fa fa-trash text-white bg-danger p-2 rounded-circle" title="Delete Parameter"></i>
        </a>
      </button>
    </h2>
    <div [id]="'collapse' + i" class="accordion-collapse collapse"
         [ngClass]="{'show': i === 0}"
         [attr.aria-labelledby]="'heading' + i"
         data-bs-parent="#parameterAccordion">
      <div class="accordion-body">

        <form class="row g-3">
          <div class="col-md-12">
            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">
                Parameter Name*
              </label>
              <div class="col-sm-10">
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type === 'view'"
                       name="parameterName"
                       [(ngModel)]="parameterDetails[i]['paramkey']"
                       placeholder="Enter parameter name"
                       class="form-control">
                <div *ngIf="formErrorParameterName[i] && error" class="text-danger fw-bold mt-1">
                  *{{formErrorParameterName[i]}}
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">
                Units*
              </label>
              <div class="col-sm-10">
                <input autocomplete="off" pattern="^[^<>]*$" type="text"
                       [disabled]="type === 'view'"
                       name="units"
                       [(ngModel)]="parameterDetails[i]['stdunit']"
                       placeholder="Enter units"
                       class="form-control">
                <div *ngIf="formErrorUnit[i] && error" class="text-danger fw-bold mt-1">
                  *{{formErrorUnit[i]}}
                </div>
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">
                Min value
              </label>
              <div class="col-sm-10">
                <input autocomplete="off" pattern="^[^<>]*$" type="number"
                       [disabled]="type === 'view'"
                       name="minValue"
                       [(ngModel)]="parameterDetails[i]['min']"
                       placeholder="Enter min value"
                       class="form-control">
              </div>
            </div>

            <div class="row mb-3">
              <label class="col-sm-2 col-form-label">
                Max value
              </label>
              <div class="col-sm-10">
                <input autocomplete="off" pattern="^[^<>]*$" type="number"
                       [disabled]="type === 'view'"
                       name="maxValue"
                       [(ngModel)]="parameterDetails[i]['max']"
                       placeholder="Enter max value"
                       class="form-control">
              </div>
            </div>

            <div class="row mb-3" *ngIf="type === 'edit'">
              <div class="col-12">
                <div class="d-flex justify-content-end gap-2">
                  <div *ngIf="!updateParameterLoader">
                    <button (click)="validateParameter(i)" type="button" class="btn btn-primary">
                      <strong>Update</strong>
                    </button>
                    <button (click)="getParameterDetail()" type="button" class="btn btn-danger ms-2">
                      <strong>Reset</strong>
                    </button>
                  </div>
                  <div *ngIf="updateParameterLoader" class="d-flex align-items-center">
                    <img src="/assets/images/load.gif" class="img-fluid" style="width: 30px;" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>

</div>
